import { ICardBenefits } from '~/src/features/movix-new/BenefitsCard';

import { ICardItem } from './Card';

let globalId = 0;

export const CARDS: ICardItem[] = [
    {
        title: <>Кeшбэк при покупке <br/> ТВ-приставки Movix</>,
        description: <>Получите 4 490 рублей баллами.<br/>Тратьте их на фильмы, сериалы и пакеты телеканалов.</>,
        buttonText: 'Подключить',
        img: 'static/images/movix-new/cashback.jpg',
        id: globalId++,
        notAllowButtonText: true,
        isBigImage: true,
    },
    {
        title: <>Купить в рассрочку<br/>или за полную стоимость</>,
        description: 'Подключите и смотрите на телевизоре более 190  ТВ-каналов, более 100 000 фильмов и сериалов, ' +
            'выходите в интернет, управляйте приставкой голосом.',
        buttonText: 'Купить приставку',
        img: 'static/images/movix-new/installment.jpg',
        fullPrice: '4 490 ₽',
        id: globalId++,
        isBigImage: true,
    },
];

export const dataHdContainer: ICardItem = {
    title: 'Высокое качество изображения',
    description: <>Смотрите фильмы такими, какими их задумывал режиссер:<br/> с кристально чёткой картинкой и идеальным звуком.</>,
    img: 'static/images/movix-new/ultra-hd-mini-m.png',
    isBigImage: true,
    id: globalId++,
};

export const dataBenefitsBlockThree: ICardBenefits[] = [
    {
        title: <>Управляйте <br/>просмотром каналов</>,
        description: 'Ставьте на паузу или перемотайте \nназад и пересмотрите тот самый гол \nпрямо во время трансляции.',
        img: 'static/images/movix-new/remotes-tv.png',
        id: globalId++,
        bgPosition: 'bottom',
        textAlign: 'flex-start',
        orderMobile: 2,
        bgSizeMobile: '40%',
        bgSize: '50%',
    },
    {
        title: 'Архив всех передач',
        description: 'Пропустили любимую передачу — \nпосмотрите её позже. Архив доступен \nещё 7 дней после эфира.',
        img: 'static/images/movix-new/channels-tv.png',
        id: globalId++,
        textAlign: 'flex-end',
        orderMobile: 3,
        bgSizeMobile: 'cover',
        bgSize: 'cover',
    },
    {
        title: 'Пропускайте рекламу',
        description: 'Смотрите фильмы и передачи из \nтелеархива без рекламы.',
        img: 'static/images/movix-new/rewind.png',
        id: globalId++,
        bgPosition: '50% 100%',
        textAlign: 'flex-start',
        orderMobile: 4,
        bgSize: '75%',
        bgSizeMobile: '75%',
    },
];

export const dataBenefitsBlockOne: [ICardItem, ICardBenefits] = [
    {
        title: 'Все ваши подписки на онлайн-кинотеатры \nв одном аккаунте',
        description: <>Теперь все платежи под контролем и оплачиваются с одного счёта — <br/>
            в едином аккаунте вы легко можете управлять подписками на онлайн-кинотеатры.</>,
        img: 'static/images/movix-new/gamer.png',
        isBigImage: true,
        id: globalId++,
    },
    {
        title: 'Для экономных',
        description: 'Покупая приставку Movix, вы получаете все возможности современного Smart TV, но значительно дешевле.',
        img: 'static/images/movix-new/discount.png',
        id: globalId++,
        textAlign: 'flex-end',
        orderMobile: 1,
        bgPosition: '0 8px',
        bgSizeMobile: 'contain',
    },
];

export const TextInfo = 'Предложение о приобретении приставки в рассрочку — по акции «Приставка в собственность» ' +
    'для абонентов услуги «Цифровое кабельное телевидение «Дом.ru TV. Центр домашних развлечений» ' +
    'при приобретении приставки с 14.03.2020 по 31.12.2023. Подключение АО «ЭР-Телеком Холдинг» ' +
    'при наличии технической возможности. Подробности на dom.ru';

export const PopupTexts = {
    title: 'Оформление заявки ',
    subtitle: 'Оставьте заявку. Мы перезвоним в ближайшее время, ответим на ваши вопросы и поможем оформить заказ.',
};
